import ABCyaPhaser from "@abcya/abcya_phaser";
import AContainer from "./ExtendedObjects/AContainer.js";
import InputHelper from "./InputHelper.js";
import Utils from "./Utils.js";
import FontKeys from "../FontKeys.js";
import gameData from "../gameData.js";
import ABCyaLib from "@abcya/abcya_lib";

export default class InputField extends AContainer {
  constructor(scene, background, textWidth, textHeight, fontSize, fontString = null, alwaysOn = false) {
    super(scene);

    this.background = background;
    if (this.background != null) {
      this.add(background);
      this.bounds = this.background.getBounds();
    }

    this.alwaysOn = alwaysOn;
    this._inputEnabled = true;
    this.textWidth = textWidth;
    this.textHeight = textHeight;
    this.fontSize = fontSize;
    this.onFocus = null;
    this.onFocusLost = null;
    this.onSubmit = null;
    this.isFocused = false;
    this.fontString = fontString ? fontString : this.scene.defaultFont;
    this.maxCharacters = 15;

    const textY = this.bounds ? this.bounds.height : 0;
    this.text = ABCyaPhaser.Text.addText(0, -4, this.fontSize, 0x5e3423, FontKeys._Tertre_Med, '', this);
    this.text.setOrigin(0, 0);
    this.keyCodes = InputHelper.KeyCodes;

    this.caretOffsetY = - 4;
    this.caretHeight = fontSize;
    this.caret = this.scene.createRect(0, 0, 2, this.caretHeight, 0x5e3423, this);
    this.caret.alpha = 0;

    if (!this.alwaysOn) {
      this.scene.input.on("pointerdown", () => {
        if (!this._inputEnabled) return;

        let bnds = this.bounds;
        let offset = Utils.StagePos(this);
        let mY = this.scene.input.y - offset.y;
        let mX = this.scene.input.x - offset.x;

        if ((mY > bnds.bottom || mY < bnds.top || mX < bnds.left || mX > bnds.right) && this.isFocused) {
          this.lostFocus();
        }
        else if (mY < bnds.bottom && mY > bnds.top && mX > bnds.left && mX < bnds.right && !this.isFocused) {
          this.gainedFocus();
          this.updateCaret();
        }
      });
    } else {
      this.gainedFocus();
      this.updateCaret();
    }

    InputHelper.GetKeyCodes((keyCode, key, ctrl, alt, shift) => {
      if (!this.isFocused || !this._inputEnabled) return;

      switch (keyCode) {
        case this.keyCodes.ENTER:
          if (this.onSubmit) this.onSubmit();

          this.scene.playSound("type_letter");

          this.scene.checkWord();
          break;
        case this.keyCodes.BACKSPACE:
          this.scene.playSound("type_letter");

          this.text.setText(this.text.text.slice(0, -1));
          this.updateTextSize();
          break;
        case this.keyCodes.SPACE:
          return;
        default:
          if (this.maxCharacters != -1 && this.text.text.length >= this.maxCharacters) return;
          if (ABCyaLib.Environment.instance.gameConfig.acceptedLetters.indexOf(key) === -1) return;

          this.scene.playSound("type_letter");

          this.text.setText(this.text.text + key);
          this.updateTextSize();
      }

      this.updateCaret();
    });
  }

  set inputEnabled(value) {
    this._inputEnabled = value;
    if (!value) this.lostFocus();
  }

  setBounds(x, y, width, height, debug = false) {
    if (debug) {
      let debugRect = this.scene.createRect(x, y, width, height, 0xff0000, this);
      debugRect.alpha = .2;
    }
    this.bounds = { top: y, left: x, right: width + x, bottom: height + y };
  }

  lostFocus() {
    this.isFocused = false;
    if (this.onFocusLost) this.onFocusLost();

    if (this.caretDelay) this.caretDelay.remove();
    this.caret.alpha = 0;
  }

  gainedFocus() {
    this.isFocused = true;
    if (this.onFocus) this.onFocus();

    this.blinkCaret();
  }

  blinkCaret() {
    if (this.caretDelay) this.caretDelay.remove();

    this.caret.alpha = !this.caret.alpha;
    this.caretDelay = this.scene.addDelay(500, () => { this.blinkCaret(); });
  }

  updateTextSize() {
    ABCyaPhaser.Text.resizeFontToFitWidth(this.text, 150, 30, this.fontSize);
  }

  updateCaret() {
    this.caret.x = this.text.width;
    this.caret.y = (this.text.height - this.caretHeight) < 0 ? 0 : this.text.height - this.caretHeight + this.caretOffsetY;
  }
}